import Blogpost from './Blogpost';

export default Blogpost;